var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoEndPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.57698 2.28306L14.2735 12.2519C14.464 12.5853 14.2233 13 13.8394 13H2.44636C2.06245 13 1.82176 12.5853 2.01224 12.2519L7.70874 2.28306C7.90068 1.94715 8.38503 1.94715 8.57698 2.28306Z",
    fill: "#F31E1E",
    stroke: "white",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEndPoint);
export default __webpack_public_path__ + "static/media/ico-end-point.1ed50c5a2f9da0fa1d92f534a21a04fc.svg";
export { ForwardRef as ReactComponent };